import React, { useCallback, useMemo } from "react";

import { SelectFilter } from "@skydio/rivet-ui";

import { useArraySearchParam } from "hooks/searchParams";
import { getReadableOrgRoles } from "utils/team";

import type { FC } from "react";
import type { ReadableOrgRole } from "utils/team";
import type { BaseProps } from "./SelectFilter";

interface Props extends BaseProps {
  onSelect?: () => void;
  label: string;
  includeRemotePilot?: boolean;
}

const MultiRoleFilterNew: FC<Props> = ({
  onSelect,
  className,
  style,
  label,
  placeholder,
  paramKey,
  includeRemotePilot = false,
}) => {
  const [selectedRoles, setSelectedRoles] = useArraySearchParam(paramKey);

  const handleSelectionChange = useCallback(
    (keys: Set<string | number>) => {
      // Convert keys to strings & serialize for URL parameter
      setSelectedRoles(Array.from(keys) as string[]);
      onSelect?.();
    },
    [setSelectedRoles, onSelect]
  );

  const roles = useMemo(() => getReadableOrgRoles(includeRemotePilot), [includeRemotePilot]);

  const roleItems = useMemo(
    () =>
      roles.map(role => (
        <SelectFilter.Item key={role.enumStringName}>{role.readableName}</SelectFilter.Item>
      )),
    [roles]
  );

  return (
    <SelectFilter<ReadableOrgRole>
      filterLabel={label}
      selectionMode="multiple"
      className={className}
      selectedKeys={selectedRoles}
      style={style}
      placeholder={placeholder}
      showSelectedValue={false}
      onSelectionChange={handleSelectionChange}
    >
      {roleItems}
    </SelectFilter>
  );
};

export default MultiRoleFilterNew;
